/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:06 GMT
 *
 */

import PaletteIconCheck from '@telus-uds/palette-koodo/build/rn/icons/Check'
const theme = {
  appearances: {
    inverse: {
      description: 'Styles the step tracker for using on dark backgrounds.',
      type: 'variant',
      values: [ true ]
    },
    style: { type: 'variant', values: [ 'default', 'bar' ] },
    viewport: {
      description: 'The size label for the current screen viewport based on the current screen width',
      type: 'state',
      values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
    }
  },
  rules: [
    {
      if: { viewport: [ 'lg', 'xl' ] },
      tokens: { showStepLabel: true, showStepTrackerLabel: false }
    },
    {
      if: { inverse: true },
      tokens: {
        completedIconColor: '#666666',
        connectorColor: '#ffffff',
        connectorCompletedColor: '#ffffff',
        knobBackgroundColor: 'transparent',
        knobBorderColor: '#ffffff',
        knobCompletedBackgroundColor: '#ffffff',
        knobCompletedBorderColor: 'transparent',
        knobCurrentBackgroundColor: 'transparent',
        knobCurrentBorderColor: '#ffffff',
        knobCurrentInnerColor: '#ffffff',
        labelColor: '#ffffff',
        labelCurrentColor: '#ffffff',
        stepLabelColor: '#ffffff'
      }
    },
    { if: { style: 'bar' }, tokens: { barGap: 4, barHeight: 8 } }
  ],
  tokens: {
    barBackgroundColor: 'rgba(0, 0, 0, 0.1)',
    barCompletedBackgroundColor: '#000000',
    barCurrentBackgroundColor: '#7a3dfc',
    barGap: null,
    barHeight: null,
    completedIcon: PaletteIconCheck,
    completedIconColor: '#ffffff',
    completedIconSize: 10,
    connectorColor: '#000000',
    connectorCompletedColor: '#000000',
    connectorCompletedHeight: 3,
    connectorHeight: 1,
    connectorMinWidth: 16,
    containerPaddingBottom: null,
    containerPaddingLeft: null,
    containerPaddingRight: null,
    containerPaddingTop: null,
    knobBackgroundColor: 'rgba(0, 0, 0, 0)',
    knobBorderColor: '#000000',
    knobBorderWidth: 1,
    knobCompletedBackgroundColor: '#000000',
    knobCompletedBorderColor: '#000000',
    knobCompletedPaddingLeft: 0,
    knobCompletedPaddingTop: 0,
    knobCurrentBackgroundColor: '#000000',
    knobCurrentBorderColor: '#000000',
    knobCurrentBorderWidth: 1,
    knobCurrentInnerColor: null,
    knobCurrentInnerSize: null,
    knobCurrentPaddingLeft: 0,
    knobCurrentPaddingTop: 0,
    knobSize: 15,
    labelColor: '#000000',
    labelCurrentColor: '#000000',
    labelCurrentFontName: 'StagSans',
    labelCurrentFontWeight: '600',
    labelDirection: 'row',
    labelFontName: 'StagSans',
    labelFontSize: 16,
    labelFontWeight: '600',
    labelGap: 4,
    labelLineHeight: 1.5,
    labelMarginTop: 10,
    labelPaddingLeft: 16,
    labelPaddingRight: 16,
    showStepLabel: false,
    showStepName: true,
    showStepTrackerLabel: true,
    stepLabelColor: '#000000',
    stepLabelFontName: 'StagSans',
    stepLabelFontSize: 16,
    stepLabelFontWeight: '600',
    stepLabelLineHeight: 1.5,
    textStepTrackerLabel: 2
  }
}
export default theme
